
<div class="environment-banner">
  <div [attr.class]="'environment-banner__container environment-banner__container--' + identifier">
    <span class="environment-banner__text">
      <ng-content></ng-content>
    </span>
  </div>
</div>
